/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.listReposByCollection'

export { $nsid }

/** Enumerates all the DIDs which have records with the given collection NSID. */
const main = l.query(
  $nsid,
  l.params({
    collection: l.string({ format: 'nsid' }),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 2000 }), 500),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    repos: l.array(l.ref<Repo>((() => repo) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type Repo = {
  $type?: 'com.atproto.sync.listReposByCollection#repo'
  did: l.DidString
}

export type { Repo }

const repo = l.typedObject<Repo>(
  $nsid,
  'repo',
  l.object({ did: l.string({ format: 'did' }) }),
)

export { repo }
